import React from 'react';
import { connect } from 'react-redux';
import ApplySelfDefinedUserIDForm from './ApplySelfDefinedUserIDForm'
import { Icons } from '@/configurations';

class ApplySelfDefinedUserIDDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowSuccessTips: false
    }
  }

  render() {
    const {language} = this.props;
    const {isShowSuccessTips} = this.state;
    return (
      <React.Fragment>
        <div style={{ width: '600px', padding: '30px' }}>
          {
            isShowSuccessTips ? <div className={'success-apply-self-defined-userid'}>
              <Icons.applySelfDefinedUserIdSuccess/>
              <div>{language.apply_self_defined_user_id_success}</div>
              <section className="action_panel">
                <button className="submit" onClick={() =>{this.props.onClose()}}>{language.common_ok}</button>
              </section>
            </div> : 
            <ApplySelfDefinedUserIDForm callback={() => this.ShowSuccessTips()}/>
          }
        </div>
      </React.Fragment>
    )
  }

  ShowSuccessTips = () => {
    this.setState({
      isShowSuccessTips: true
    })
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(ApplySelfDefinedUserIDDialog)